import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { CommissionDetails } from '../modal';


export default function reducer(state: CommissionDetails = new CommissionDetails(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.COMMISSION_DETAILS_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.COMMISSION_DETAILS_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.COMMISSION_DETAILS_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
